import { render, staticRenderFns } from "./CustomerReview.vue?vue&type=template&id=d416c73a"
import script from "./CustomerReview.vue?vue&type=script&lang=js"
export * from "./CustomerReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CustomerReview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/checkout-webapp-v2/checkout-webapp-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d416c73a')) {
      api.createRecord('d416c73a', component.options)
    } else {
      api.reload('d416c73a', component.options)
    }
    module.hot.accept("./CustomerReview.vue?vue&type=template&id=d416c73a", function () {
      api.rerender('d416c73a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/review/CustomerReview.vue"
export default component.exports